import RoxLogger from './RoxLogger';

export const ExceptionTrigger = {
  DYNAMIC_PROPERTIES_RULE: 'DYNAMIC_PROPERTIES_RULE',
  CONFIGURATION_FETCHED_HANDLER: 'CONFIGURATION_FETCHED_HANDLER',
  IMPRESSION_HANDLER: 'IMPRESSION_HANDLER',
  CUSTOM_PROPERTY_GENERATOR: 'CUSTOM_PROPERTY_GENERATOR'
};

class UserspaceUnhandledErrorInvoker {
  userUnhandledErrorHandler
  invoke(exceptionTrigger, error) {
    if (!this.userUnhandledErrorHandler) {
      RoxLogger.error('User Unhandled Error Occured, no fallback handler was set, exception ignored.', error);
      return;
    }

    try {
      this.userUnhandledErrorHandler(exceptionTrigger, error);
    } catch (err) {
      RoxLogger.error('User Unhandled Error Handler itself threw an exception. original exception:' + error, err);
    }
  }

  setHandler(handler) {
    if (!(handler instanceof Function)) {
      RoxLogger.warn('UserspaceUnhandledErrorHandler must be a function. default will be used.');
      return;
    }
    this.userUnhandledErrorHandler = handler;
  }
}

// wanted to create with new on client.js and pass it as an object, but 'new RoxParser()' appears in too many places :(
export default new UserspaceUnhandledErrorInvoker();
